import { Spinner } from 'office-ui-fabric-react';
import * as React from 'react';

import {
  ITextFieldOwnProps,
  LogEventName,
  LogLevel} from '../../models';
import { createStructuredSelector, mconnect } from '../../state/redux';
import { IStyledComponent, styledComponent } from '../../theme';
import { IComponentStateProps, IConnectedComponentProps } from '../../types';
import { generateAdhocs, setDangerouslyInnerHtml } from '../../utils';
import {
  getTextFieldComponentSpinnerStyles,
  getTextFieldDefaultClassNames,
  getTextFieldDefaultStyles,
  IDefaultTextFieldStyles
} from '../intentGraph.styles';
import { isFetchingResourceSelector, resourceSelector } from '../reducers/selectors.redux';

const mapStateToProps = createStructuredSelector({
  resource: resourceSelector,
  isFetchingResource: isFetchingResourceSelector
});

const mapDispatchToProps = {}

type ITextFieldProps = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & ITextFieldOwnProps &
  IConnectedComponentProps &
  IComponentStateProps &
  IStyledComponent<IDefaultTextFieldStyles> & {
    ariaLive?: 'polite' | 'assertive' | 'off';
  }

class TextFieldC extends React.PureComponent<ITextFieldProps> {
  constructor(props: ITextFieldProps) {
    super(props);
  }

  public render = (): React.ReactNode => {
    const defaultClassNames = getTextFieldDefaultClassNames(this.props.styles, {
      theme: this.props.theme,
      stylesFunc: this.props.stylesFunc
    });
    const text = !!this.props.resource ? this.props.resource.SolutionContent : null;
    const title = !!this.props.resource ? this.props.resource.SolutionTitle : null;
    return this.props.isFetchingResource ? (
      <Spinner styles={getTextFieldComponentSpinnerStyles(this.props)} />
    ) : (
      <>
        {!!title && (
          <div key={this.props.componentkey + '-title'} className={this.props.titleClassName}>
            {title}
          </div>
        )}
        {!!text && text !== '' && (
          <div
            {... (!!this.props.node?.get('text')?.get('dynamic') ? {"aria-live": "polite"} : {})}
            role="alert"
            onClick={this.onClickHandler}
            key={this.props.componentkey + '-content'}
            className={`${this.props.className} ${defaultClassNames.textFieldBase}`}
            dangerouslySetInnerHTML={setDangerouslyInnerHtml(text)}
          />
        )}
      </>
    );
  };

  private onClickHandler = (ev: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (
      this.props.logLinkClicks &&
      this.props.callbackHandlers.LogHandler &&
      typeof this.props.callbackHandlers.LogHandler === 'function' &&
      ev
    ) {
      const el = ev.target as HTMLElement;
      if (el && el.tagName && el.tagName.toLowerCase() === 'a') {
        this.props.callbackHandlers.LogHandler(
          LogEventName.onLinkClick,
          LogLevel.Info,
          this.props.sessionId,
          el.outerHTML,
          generateAdhocs(this.props.meta, undefined, undefined, this.props.node)
        );
      }
    }
  };
}

export const TextFieldComponent = mconnect(mapStateToProps, mapDispatchToProps)(styledComponent(TextFieldC, getTextFieldDefaultStyles));
